var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaccarat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 10,
    height: 14,
    rx: 1.5,
    transform: "rotate(-12 5.5 12.5)",
    fill: "#8a939c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 10,
    height: 14,
    rx: 1.5,
    fill: "#9aa3ab"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 10,
    height: 14,
    rx: 1.5,
    transform: "rotate(10 13 12)",
    fill: "#B3BEC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 9C12.8 8.2 14 8.2 14.3 9C14.6 9.8 13.3 11.5 13.25 11.5C13.2 11.5 11.9 9.8 12.2 9Z",
    fill: "#1a1a2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaccarat);
export default __webpack_public_path__ + "static/media/baccarat.f3d60a89e553f98a894b6465efd0d21e.svg";
export { ForwardRef as ReactComponent };